import { AbstractControl } from '@angular/forms';

export function containDigitValidator(control: AbstractControl) {
    var regex = /([0-9)])/;
    var value = control.value;
    if (value != null && !regex.test(value)) {
        return { containDigit: true };
    }
}